import { createActionCreator } from '../utils/helpers';

import { companyUsers } from './types';

export const requestCompanyUsers = createActionCreator(companyUsers.request, 'entityId');
export const requestCompanyUsersSuccess = createActionCreator(
  companyUsers.success,
  'entityId',
  'response',
);
export const requestCompanyUsersFailure = createActionCreator(
  companyUsers.failure,
  'entityId',
  'error',
);
